import ProfilLayout from "../../ProfilLayout/ProfilLayout";
import {
    ContactsContext,
    CustomModalContext,
    InitDataContext,
    LayoutBarContext,
} from "../../../../contexts";
import { useCallback, useContext, useEffect } from "react";
import ProfilCardsList from "../../ProfilCardsList/ProfilCardsList";
import EditManagerForm from "./Forms/EditManagerForm";
import EditProjectManagerForm from "./Forms/EditProjectManagerForm";
import EditBillingManagerForm from "./Forms/EditBillingManagerForm";
import ProfilHome from "../../ProfilHome";
import { ContactProfilsEnum, Session } from "../../../../types";
import { useLocalStorage } from "../../../../hooks";
import { sessionStorageKey, contactsStorageKey } from "../../../../consts";
import { getContactsOfEstablishement, putContact } from "../../../../services";

export default function Contacts() {
    const { updateContacts, ...contactsInfo } = useContext(ContactsContext);

    const { updateContent } = useContext(LayoutBarContext);

    const { updateModal, updateIsCustomModalActive } =
        useContext(CustomModalContext);

    const { storedValue: session } =
        useLocalStorage<Session>(sessionStorageKey);

    const {
        auth: { user: currentUser },
    } = session;

    const { ...dataInit } = useContext(InitDataContext);

    const getContactProfilsFromStorage = () => {
        const contactProfilsFromContext = dataInit[contactsStorageKey].profils;
        if (contactProfilsFromContext.length) {
            return contactProfilsFromContext;
        }
        const {
            [contactsStorageKey]: { profils: contactProfils },
        } = session;
        return contactProfils;
    };

    const contactProfils = getContactProfilsFromStorage();

    const { contacts } = contactsInfo;
    const managerProfilId = (
        contactProfils.find((cp) => cp.code === ContactProfilsEnum.MANAGER) ||
        {}
    ).id;
    const projectManagerProfilId = (
        contactProfils.find(
            (cp) => cp.code === ContactProfilsEnum.PROJECT_MANAGER
        ) || {}
    ).id;

    const billingManagerProfilId = (
        contactProfils.find(
            (cp) => cp.code === ContactProfilsEnum.BILLING_MANAGER
        ) || {}
    ).id;

    const managerProfil = contacts.find(
        (c) => managerProfilId && c.profil === managerProfilId
    );

    const billingMangerProfil = contacts.find(
        (c) => billingManagerProfilId && c.profil === billingManagerProfilId
    );

    const projectMangerProfil = contacts.find(
        (c) => projectManagerProfilId && c.profil === projectManagerProfilId
    );

    const getConcernedProfil = (contactsEdited: any, profilId: any) => {
        return contactsEdited.find((c: any) => c.profil === profilId);
    };

    const handleUpdateProfil = useCallback(
        async (ContactsFormData: any, profilId: number | undefined) => {
            if (profilId) {
                const { contacts: contactsEdited } = ContactsFormData;
                const concernedProfil = getConcernedProfil(
                    contactsEdited,
                    profilId
                );

                const puttingContact = await putContact(
                    concernedProfil.id,
                    concernedProfil
                );
                if (!puttingContact.detail) {
                    updateContacts(ContactsFormData);
                    updateIsCustomModalActive(false);
                }
            }
        },
        []
    );

    const contactProfilCards = [
        {
            key: "manager",
            value:
                (managerProfil &&
                    managerProfil?.firstName + " " + managerProfil?.lastName) ??
                "",
            label: "Dirigeant",
            onClick: async () => {
                updateModal({
                    content: (
                        <EditManagerForm
                            profilId={managerProfilId + ""}
                            onSubmit={async (ContactsFormData: any) => {
                                await handleUpdateProfil(
                                    ContactsFormData,
                                    managerProfilId
                                );
                            }}
                            defaultValue={{
                                contacts,
                            }}
                        />
                    ),
                    title: "Modifier le contact",
                });
                updateIsCustomModalActive(true);
            },
        },
        {
            key: "projectManager",
            value:
                (projectMangerProfil &&
                    projectMangerProfil?.firstName +
                        " " +
                        projectMangerProfil?.lastName) ??
                "",
            label: "Responsable projet de qualification",
            onClick: async () => {
                updateModal({
                    content: (
                        <EditProjectManagerForm
                            profilId={projectManagerProfilId + ""}
                            onSubmit={async (ContactsFormData: any) => {
                                await handleUpdateProfil(
                                    ContactsFormData,
                                    projectManagerProfilId
                                );
                            }}
                            defaultValue={{
                                contacts,
                            }}
                        />
                    ),
                    title: "Modifier le contact",
                });
                updateIsCustomModalActive(true);
            },
        },
        {
            key: "billingManager",
            value:
                (billingMangerProfil &&
                    billingMangerProfil?.firstName +
                        " " +
                        billingMangerProfil?.lastName) ??
                "",
            label: "Responsable facturation",
            onClick: async () => {
                updateModal({
                    content: (
                        <EditBillingManagerForm
                            profilId={billingManagerProfilId + ""}
                            onSubmit={async (ContactsFormData: any) => {
                                await handleUpdateProfil(
                                    ContactsFormData,
                                    billingManagerProfilId
                                );
                            }}
                            defaultValue={{
                                contacts,
                            }}
                        />
                    ),
                    title: "Modifier le contact",
                });
                updateIsCustomModalActive(true);
            },
        },
    ];

    const fetchContactsOfEstablishment = useCallback(
        async (establishementId: number) => {
            const contactsOfEstablishementRes =
                await getContactsOfEstablishement(establishementId);
            if (!contactsOfEstablishementRes.detail) {
                updateContacts({ contacts: contactsOfEstablishementRes });
            }
        },
        []
    );

    const establishement = currentUser.establishment;

    useEffect(() => {
        if (establishement) {
            fetchContactsOfEstablishment(establishement);
        }
    }, [fetchContactsOfEstablishment]);

    return (
        <ProfilLayout
            headerTitle={"Contacts"}
            onBackClick={() => {
                updateContent(<ProfilHome />);
            }}
        >
            <ProfilCardsList profilCardItems={contactProfilCards} />
        </ProfilLayout>
    );
}
